import { render, staticRenderFns } from "./ClientSuperUsers.vue?vue&type=template&id=41a829d6&"
import script from "./ClientSuperUsers.vue?vue&type=script&lang=js&"
export * from "./ClientSuperUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports